/**
 * Truncate a string to the specified length and append an ellipsis (...) if truncated.
 * @param str - The string to truncate.
 * @param maxLength - The maximum length of the string.
 * @returns The truncated string with ellipsis if needed.
 */
export const truncateString = (str: string, maxLength: number): string => {
    if (str.length <= maxLength) {
        return str;
    }
    return `${str.slice(0, maxLength)}...`;
};
